/**
 * Generate a consistent color for an avatar based on a string (name)
 * Returns background and text color combination
 * @param name - The name to generate colors from
 * @param customColor - Optional custom hex color to use instead of generated color
 */
export const getAvatarColors = (name: string, customColor?: string | null): { backgroundColor: string; color: string } => {
  // If custom color is provided, use it
  if (customColor && /^#[0-9A-F]{6}$/i.test(customColor)) {
    return {
      backgroundColor: customColor,
      color: '#ffffff'
    };
  }

  // Color combinations with good contrast
  const colorPairs = [
    { backgroundColor: '#1976d2', color: '#ffffff' }, // Blue
    { backgroundColor: '#d32f2f', color: '#ffffff' }, // Red
    { backgroundColor: '#388e3c', color: '#ffffff' }, // Green
    { backgroundColor: '#f57c00', color: '#ffffff' }, // Orange
    { backgroundColor: '#7b1fa2', color: '#ffffff' }, // Purple
    { backgroundColor: '#0097a7', color: '#ffffff' }, // Cyan
    { backgroundColor: '#c2185b', color: '#ffffff' }, // Pink
    { backgroundColor: '#5d4037', color: '#ffffff' }, // Brown
    { backgroundColor: '#455a64', color: '#ffffff' }, // Blue Grey
    { backgroundColor: '#00796b', color: '#ffffff' }, // Teal
    { backgroundColor: '#303f9f', color: '#ffffff' }, // Indigo
    { backgroundColor: '#689f38', color: '#ffffff' }, // Light Green
    { backgroundColor: '#e64a19', color: '#ffffff' }, // Deep Orange
    { backgroundColor: '#512da8', color: '#ffffff' }, // Deep Purple
    { backgroundColor: '#0288d1', color: '#ffffff' }, // Light Blue
  ];

  // Generate a consistent hash from the name
  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    hash = name.charCodeAt(i) + ((hash << 5) - hash);
    hash = hash & hash; // Convert to 32bit integer
  }

  // Use hash to select a color pair
  const index = Math.abs(hash) % colorPairs.length;
  return colorPairs[index];
};
